/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./ColorSelect.css'); }
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-colorSelect");
exports.ColorSelect = function ColorSelect(_a) {
    var label = _a.label, className = _a.className, onChange = _a.onChange, value = _a.value, colors = _a.colors, abbreviation = _a.abbreviation, props = tslib_1.__rest(_a, ["label", "className", "onChange", "value", "colors", "abbreviation"]);
    return (React.createElement("div", tslib_1.__assign({ className: classnames(moduleClassName(), className) }, props),
        React.createElement("label", { className: moduleClassName("label") }, label),
        colors.map(function (color) { return (React.createElement("button", { key: color, style: { backgroundColor: color }, onClick: function () { return onChange(color); }, type: "button", name: color, "aria-selected": value === color, className: classnames(moduleClassName("option"), value === color && moduleClassName("option-isSelected")) },
            React.createElement("svg", { viewBox: "0 0 20 20", className: moduleClassName("checkIcon") },
                React.createElement("polyline", { points: "4 11 8 15 16 6" })),
            abbreviation && (React.createElement("span", { className: moduleClassName("abbreviation") }, abbreviation)))); })));
};
exports.ColorSelect.propTypes = {
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    colors: PropTypes.arrayOf(PropTypes.string).isRequired,
    value: PropTypes.string,
    abbreviation: PropTypes.string
};